import { render, staticRenderFns } from "./PackModal.vue?vue&type=template&id=45ec2606"
import script from "./PackModal.vue?vue&type=script&lang=js"
export * from "./PackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports